import { ShopSelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  start_date: {
    'ui:field': 'date',
  },
  end_date: {
    'ui:field': 'date',
  },
  description: {
    'ui:widget': 'textarea',
  },
  amount: {
    'ui:options': {
      adornment: 'تومان',
      convertToWord: true,
    },
  },
  shop_id: {
    'ui:widget': ShopSelectionWidget,
    'ui:options': {
      initFilter: {
        status_ids: ["2"],
      },
    },
  },
  // category_id: {
  //   'ui:widget': CouponCategorySelectionWidget,
  // },
});

export default uiSchema;
